
import Vue from 'vue';

import { categories } from '@root/modules/customer/config/customer.config';
import { GetCustomerData } from '@root/modules/customer/types/customer';
import { faChevronLeft, faChevronRight, faPencil } from '@delfi.lt/fa-kit/icons/modules/classic/light';

interface Category {
  key: string;
  name: string;
  categories: number[];
}

interface Data {
  categories: Category[];
  selectedCategories: string[];
  menu: any;
  menuScrollWidth: number;
  menuScrollLeft: number;
  menuClientWidth: number;
}
interface Props {
  usersCategories: GetCustomerData['data']['data'] | null;
}
interface Methods {
  getCategoryName: (key: string) => string;
  setActivePage: (page: string) => void;
  scrollTo: (id: string) => void;
  updateNavigation: (distance: number) => void;
  handleScroll: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  data() {
    return {
      categories,
      selectedCategories: [],
      menu: null,
      menuScrollWidth: 0,
      menuScrollLeft: 0,
      menuClientWidth: 0,
      faChevronLeft,
      faChevronRight,
      faPencil,
    };
  },
  props: {
    usersCategories: {
      type: Object || null,
      default: null,
    },
  },
  methods: {
    getCategoryName(key) {
      const item = this.categories.find((item) => item.key === key);
      const categoryName = item?.name ? item?.name : '';
      return categoryName;
    },
    setActivePage(page) {
      this.$emit('set-active-page', page);
    },
    scrollTo(id) {
      const element = document.getElementById(`${id}-headlines`);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth',
        });
      }
    },
    updateNavigation(distance) {
      const menu = this.$refs.menuRow as HTMLElement;
      if (menu) {
        menu.style.scrollBehavior = 'smooth';
        menu.scrollLeft += distance;
      }
    },
    handleScroll() {
      if (this.menu) {
        this.menu.addEventListener('scroll', () => {
          if (this.menu.scrollTop > 0 || this.menu.scrollLeft > 0) {
            this.menuScrollWidth = this.menu.scrollWidth;
            this.menuScrollLeft = this.menu.scrollLeft;
            this.menuClientWidth = this.menu.clientWidth;
          }
        });
      }
    },
  },
  mounted() {
    if (process.client && window && window.innerWidth > 768) {
      this.$nextTick(() => {
        this.menu = this.$refs.menuRow as HTMLElement;
        if (this.menu) {
          this.menuScrollWidth = this.menu.scrollWidth;
          this.menuScrollLeft = this.menu.scrollLeft;
          this.menuClientWidth = this.menu.clientWidth;
          this.menu.addEventListener('scroll', this.handleScroll);
        }
      });
    }
  },
  beforeDestroy() {
    if (this.menu) {
      this.menu.removeEventListener('scroll', this.handleScroll);
    }
  },
});
